import { Injectable, TemplateRef } from '@angular/core';

export interface ToastInfo {
	textOrTpl: any;
	classname: string;
	header: string;
	delay?: number;
  	name?: string;
	persistent: boolean,
  }  

@Injectable({ providedIn: 'root' })
export class ToastService {
	toasts: ToastInfo[] = [];

	show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
		let params = { textOrTpl, ...options }
		this.toasts.push(params);
	}

	showPersistentWarning(header: string, message: string | TemplateRef<any>, name: string) {
		// Remove any existing persistent toast with same name
		this.toasts = this.toasts.filter(t => t.name !== name);
		this.toasts.push({
			textOrTpl: message,
			classname: 'bg-warning text-dark p-3 fs-5',
			header,
			name,
			persistent: true
		});
	}

	clearPersistentWarning(name: string) {
		this.toasts = this.toasts.filter(t => t.name !== name);
	}

	remove(toast : any) {
		this.toasts = this.toasts.filter((t) => t !== toast);
	}

	clear() {
		this.toasts = this.toasts.filter(p => !p.persistent);
	}
}